import { pictureInit } from './timelines/picture';
import { paragraphInit } from './timelines/typography';

const initialStates = new Map();

initialStates.set('picture', pictureInit);
initialStates.set('paragraph', paragraphInit);

export default initialStates;
